import {
  defaultTo,
  last,
  map,
  path,
  pipe,
} from 'ramda';
import { CUSTOM_REPORTS_PATH } from './constants';

export const getCustomReportLink = item => `${CUSTOM_REPORTS_PATH}/${item.id}`;
export const getEditCustomReportLink = item => `${CUSTOM_REPORTS_PATH}/${item.id}/edit`;

export const getActiveDropdownItem = (items, pathname) => (
  items.find((item) => {
    const regex = RegExp(`${getCustomReportLink(item)}$`);
    return regex.test(pathname);
  })
);

export const isDropdownItemActive = (allItems, itemToCheck, pathname) =>
  itemToCheck === getActiveDropdownItem(allItems, pathname);

export const isDropdownLabelActive = (items, pathname) => !!getActiveDropdownItem(items, pathname);

export const getDropdownLabel = (items, pathname) => (
  pipe(
    path(['name']),
    defaultTo('Custom Reports')
  )(getActiveDropdownItem(items, pathname))
);

export const getApiReportFromFormValues = (formValues, brandId) => {
  const apiValues = {
    ...formValues,
    reportMetrics: map(metric => ({
      metricId: metric.metricId,
      // 'breakdownSelected' is required in api even for non-breakdownable metrics :(
      breakdownSelected: metric.breakdownSelected || false,
    })
    , formValues.reportMetrics),
  };
  if (brandId) {
    apiValues.brandId = brandId;
  }
  return apiValues;
};

export const getDownloadFileName = (responseHeaders, defaultName = 'file.txt') => {
  const contentDisposition = responseHeaders.get('content-disposition') || '';
  return last(contentDisposition.split('=')) || defaultName;
};
